module.exports = __webpack_public_path__ + "img/Medical.facbbe82.png";